import { createFileRoute } from "@tanstack/react-router";
import { ArticleCardGrid } from "@/components/article-layout";
import { allGeoArticles } from "@/lib/geo-data";
import { seo } from "@/lib/seo";
import { breadcrumb, collectionPage } from "@/lib/structured-data";
import { SITE_URL } from "@/lib/seo-constants";

const DESCRIPTION =
  "What generative engine optimization is, how it differs from SEO, and how to structure content AI engines cite: mention rate, citation rate, prompt clusters.";

export const Route = createFileRoute("/geo/")({
  head: () =>
    seo({
      title: "GEO, AEO & SEO — Generative Engine Optimization Fundamentals",
      description: DESCRIPTION,
      path: "/geo",
      type: "website",
      jsonLd: [
        collectionPage({
          name: "Generative Engine Optimization (GEO) fundamentals",
          description: DESCRIPTION,
          url: `${SITE_URL}/geo`,
          items: allGeoArticles.map((a) => ({ name: a.title, url: `/geo/${a.slug}` })),
        }),
        breadcrumb([
          { name: "Home", url: "/" },
          // Spelled out, not "GEO" — this is where the entity is disambiguated.
          { name: "Generative Engine Optimization (GEO)", url: "/geo" },
        ]),
      ],
    }),
  component: GeoIndex,
});

function GeoIndex() {
  return (
    <div>
      <p className="text-[11px] font-medium uppercase tracking-[0.22em] text-muted-foreground mb-3">
        Fundamentals
      </p>
      <h1 className="text-4xl md:text-5xl font-semibold tracking-tight mb-4">
        Generative Engine Optimization fundamentals
      </h1>
      <p className="text-lg text-muted-foreground max-w-2xl mb-12 text-pretty">
        Generative Engine Optimization (GEO) — and its close cousin Answer Engine Optimization (AEO)
        — is the practice of earning mentions and citations inside AI answers rather than blue
        links. These guides define the concepts, the metrics, and the content patterns that get you
        cited.
      </p>

      <ArticleCardGrid articleRoute="/geo/$slug" items={allGeoArticles} />
    </div>
  );
}
